import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { ThemeColor } from "../../theme/palette";

const TRACK_BG = "#0c1117";
const SEGMENT_ACTIVE_BG = "#1e2a3a";
const TEXT_MUTED = "whiteAlpha.700";

interface StakeSlippageSelectorProps {
  label?: string;
  showLabel?: boolean;
  options: number[];
  value: number;
  onChange: (value: number) => void;
}

export const StakeSlippageSelector = ({
  label = "Slippage",
  showLabel = true,
  options,
  value,
  onChange,
}: StakeSlippageSelectorProps) => {
  const track = (
    <Box
      role="group"
      aria-label={label}
      bg={TRACK_BG}
      borderRadius="xl"
      border="1px solid"
      borderColor="whiteAlpha.200"
      p="3px"
      flex={showLabel ? 1 : undefined}
      maxW="240px"
      w={showLabel ? undefined : "100%"}
    >
      <Flex gap="3px">
        {options.map((option) => {
          const isActive = value === option;
          return (
            <Button
              key={option}
              type="button"
              flex={1}
              variant="unstyled"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRadius="lg"
              py={2}
              px={2}
              minH="36px"
              bg={isActive ? SEGMENT_ACTIVE_BG : "transparent"}
              boxShadow={isActive ? "inset 0 0 0 1px rgba(95, 244, 244, 0.35)" : "none"}
              transition="background 0.2s ease, box-shadow 0.2s ease, color 0.2s ease"
              onClick={() => onChange(option)}
              _hover={{
                bg: isActive ? SEGMENT_ACTIVE_BG : "whiteAlpha.100",
              }}
              _focusVisible={{
                boxShadow: "0 0 0 2px rgba(95, 244, 244, 0.5)",
              }}
            >
              <Text
                fontSize="sm"
                fontWeight={isActive ? "semibold" : "medium"}
                color={isActive ? ThemeColor.KAIROS : TEXT_MUTED}
              >
                {option}%
              </Text>
            </Button>
          );
        })}
      </Flex>
    </Box>
  );

  if (!showLabel) return track;

  return (
    <Flex justify="space-between" align="center" gap={3} width="100%">
      <Text fontSize="xs" color={TEXT_MUTED} flexShrink={0}>
        {label}
      </Text>
      {track}
    </Flex>
  );
};
